module.exports = __webpack_public_path__ + "img/getIntegral.9efe0096.png";